import React from 'react';
import HsmSubnetColumn from '../../../shared/component/dataTable/columns/HsmSubnetColumn';
import DataTableAll from "../../../shared/component/dataTable/DataTableAll";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import { Button } from "reactstrap";
import Translate from "../../../shared/language/Translate";
import BbProductColumn from "../../../shared/component/dataTable/columns/BbProductColumn";
import { PAGE_MODE, TENANT_ID } from "../../../shared/utils/Constants";
import Dialog from "../../../shared/component/dialog/Dialog";
import HsmSubnetSave from "./HsmSubnetSave";
import HsmSubnetAutoForm from "./HsmSubnetAutoForm";
import HsmSubnetService from "../../../shared/service/HsmSubnetService";
import HsmSubnetPoolService from "../../../shared/service/HsmSubnetPoolService";
import { toast } from "react-toastify";
import TenantService from "../../../shared/service/TenantService";
import Loading from "../../../shared/component/others/Loading";
import ModalConfirm from "../../request/hsmDialog/ModalConfirm";

export default class HsmSubnet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hsmSubnetList: [],
            hsmSubnetRemovedList: [],
            pageMode: PAGE_MODE.UPDATE,
            locationId: null,
            organizationId: null,
            serviceRequestId: null,
            loading: false
        };
        this.service = new HsmSubnetService();
        this.hsmSubnetPoolService = new HsmSubnetPoolService();
        this.tenantService = new TenantService();
    }

    componentDidMount = () => {
        this.tenantService.getTenant().then(result => {
            this.setState({ tenantId: result });
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.data) {
            this.setState({ hsmSubnetList: nextProps.data, pageMode: nextProps.pageMode, status: nextProps.status });
        }
        if (!GeneralUtils.isNullOrEmpty(nextProps.locationId) && !GeneralUtils.isNullOrEmpty(nextProps.organizationId)) {
            this.setState({ locationId: nextProps.locationId, organizationId: nextProps.organizationId });
        }
        if (!GeneralUtils.isNullOrEmpty(nextProps.serviceRequestId)) {
            this.setState({ serviceRequestId: nextProps.serviceRequestId });
        }
    }

    resumeCheck = () => {
        if (this.state.serviceRequestId == null) {
            this.setState({ displayConfirmDialogResume: false });
            this.autoLoadForSubnetPool();
        } else {
            this.setState({
                displayConfirmDialogResume: true,
                noticeResponse: "Otomatik getirilen IP adresleri otomatik olarak kaydedilecektir. Devam etmek istiyor musunuz?"
            });
        }
    }

    render() {
        return (
            <div>
                {(this.state.pageMode !== PAGE_MODE.VIEW || this.state.status === 'DRAFT' || this.state.status === 'AWAITING_APPROVAL') &&
                    <Toolbar display={true}>
                        <div className="p-toolbar-group-right">
                            <Button color="primary" onClick={this.addNew}>
                                <Translate contentKey="entity.action.add">Subnet Ekle</Translate>
                            </Button>
                        </div>
                        {this.state.tenantId == TENANT_ID.MEB &&
                            <div className="p-toolbar-group-right">
                                <Button color="primary" onClick={this.openFormForAutoLoadSubnetPool}>
                                    <Translate contentKey="entity.action.add">Otomatik Getir</Translate>
                                </Button>
                            </div>
                        }
                    </Toolbar>}
                <DataTableAll ref={(elem) => this.refDataTable = elem} fields={HsmSubnetColumn.fields}
                    data={this.state.hsmSubnetList} objectName={HsmSubnetColumn.name} autoLoad={false}
                    selectionMode={(this.state.pageMode !== PAGE_MODE.VIEW || this.state.status === 'DRAFT') ? "single" : null}
                    onDataSelect={this.onDataSelect} privilege="allow" />

                <Dialog visible={this.state.displayDialog}
                    header={GeneralUtils.getDialogHeader('Subnet ', this.state.pageMode)} modal={true}
                    onHide={() => this.setState({ displayDialog: false })} style={{ width: '50vw' }}>
                    <HsmSubnetSave
                        ref={(elem) => this.refHsmSubnetSave = elem}
                        closeDisplayDialog={this.closeDisplayDialog}
                        refresh={this.refresh}
                        add={this.getListItem} delete={this.deleteListItem}
                        checkName={this.checkName}
                    />
                </Dialog>
                <Dialog visible={this.state.displayDialogAuto}
                    header="Otomatik Getir" modal={true}
                    onHide={() => this.setState({ displayDialogAuto: false })} style={{ width: '20vw' }}>
                    <HsmSubnetAutoForm
                        ref={(elem) => this.refHsmSubnetAuto = elem}
                        closeDisplayDialogAuto={this.closeDisplayDialogAuto}
                        autoLoadForSubnetPool={this.resumeCheck}
                    />
                    {this.state.loading && <Loading />}
                </Dialog>

                <ModalConfirm header='Uyarı' ok='Devam Et' onOkClick={this.autoLoadForSubnetPool}
                    onCancelClick={() => this.setState({ displayConfirmDialogResume: false })}
                    show={this.state.displayConfirmDialogResume}
                    message={this.state.noticeResponse} />
            </div>
        );
    }

    refresh = () => {
        this.refDataTable.setParameter(this.state.productId);
        this.setState({ displayDialog: false });
    }

    addNew = () => {
        this.setState({ displayDialog: true, pageMode: PAGE_MODE.UPDATE, activeIndex: 0 });
        this.refHsmSubnetSave.clearData();
        this.refHsmSubnetSave.setAssetIdAndPageMode(this.state.productId, PAGE_MODE.UPDATE);
    }

    setData = (data, pageMode) => {
        this.clearData();
        this.setState({ locationId: data.locationId.id, organizationId: data.organizationId.id })
        this.service.findByProductId(data.id).then(response => {
            this.setState({ hsmSubnetList: response ? response : [], pageMode: pageMode, productId: data.id })
        });
    }

    getData = () => {
        return this.state.hsmSubnetList;
    }

    getDataRemoved = () => {
        return this.state.hsmSubnetRemovedList;
    }

    clearData = () => {
        this.setState({ hsmSubnetList: [], hsmSubnetRemovedList: [], productId: null, displayAutoLoadSubnet: false })
    }

    onDataSelect = (data) => {
        let pageMode = GeneralUtils.getPageModeFromPrivilege(BbProductColumn.name);
        this.setState({ displayDialog: true, pageMode: pageMode });
        this.refHsmSubnetSave.clearData();
        this.refHsmSubnetSave.setData(Object.assign({}, data), pageMode);
    }

    closeDisplayDialog = () => {
        this.setState({ displayDialog: false });
    }

    closeDisplayDialogAuto = () => {
        this.setState({ displayDialogAuto: false });
    }

    setPageMode = (pageMode) => {
        this.setState({ pageMode: pageMode });
    }

    getListItem = (data) => {
        let hsmSubnetList = this.arrayRemove(this.state.hsmSubnetList, data);
        hsmSubnetList.push(data);
        this.setState({ hsmSubnetList: hsmSubnetList });
        if (this.props.setHsmSubnetList) {
            this.props.setHsmSubnetList(hsmSubnetList);
        }
    }

    deleteListItem = (data) => {
        let hsmSubnetRemovedList = this.state.hsmSubnetRemovedList;
        hsmSubnetRemovedList.push(data);
        let hsmSubnetList = this.arrayRemove(this.state.hsmSubnetList, data);
        this.setState({ hsmSubnetList: hsmSubnetList, hsmSubnetRemovedList: hsmSubnetRemovedList })
        if (this.props.setHsmSubnetList) {
            this.props.setHsmSubnetList(hsmSubnetList);
        }
    }

    arrayRemove = (arr, element) => {
        return arr.filter(function (el) {
            return el.name !== element.name;
        });
    }

    checkName = (hsmSubnet) => {
        let hsmSubnetList = this.state.hsmSubnetList;
        for (let i = 0; i < hsmSubnetList.length; i++) {
            if (hsmSubnetList[i].name === hsmSubnet.name && hsmSubnetList[i].id !== hsmSubnet.id) {
                return true;
            }
        }
        return false;
    }

    setPageModeAndStatus = (pageMode, status) => {
        this.setState({ pageMode: pageMode, status: status });
    }

    openFormForAutoLoadSubnetPool = () => {
        this.setState({ displayDialogAuto: true });
        this.refHsmSubnetAuto.clearData();
        this.refHsmSubnetAuto.setAssetIdAndPageMode(this.state.productId, PAGE_MODE.VIEW);
    }

    autoLoadForSubnetPool = () => {
        var organizationId = this.state.organizationId;
        var serviceRequestId = this.state.serviceRequestId;
        var hsmSubnetAuto = this.refHsmSubnetAuto.getHsmSubnetAuto();

        if (hsmSubnetAuto != null &&
            this.isNumberInRange(hsmSubnetAuto.mebNetworkMask) &&
            this.isNumberInRange(hsmSubnetAuto.reelNetworkMask)) {
            this.setState({ loading: true });
            if (serviceRequestId != null) {
                hsmSubnetAuto.serviceRequestId = serviceRequestId;
            }
            this.hsmSubnetPoolService.findByOrganizationId(organizationId, hsmSubnetAuto).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && response.length > 0) {
                    response.forEach((element) => {
                        element.id = null;
                    });
                    toast.info('IP havuzundan ilgili il için uygun IP paketi getirilmiştir.');
                    this.setState({ hsmSubnetList: response });
                    this.closeDisplayDialogAuto();
                } else {
                    toast.info('IP havuzunda ilgili il için uygun IP bulunamamıştır.');
                    this.setState({ hsmSubnetList: [] });
                }
                this.setState({ loading: false });
            });
        }
        else {
            toast.info('Lütfen geçerli değerler giriniz.');
        }
    }

    isNumberInRange = (value) => {
        const num = parseFloat(value);
        if (!isNaN(num) && num >= 0 && num <= 32) {
            return true;
        }
        return false;
    }
}
